const dateFormat = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
})
const timeFormat = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' })

function parse(value) {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatEventSchedule(startValue, endValue) {
  const start = parse(startValue)
  const end = parse(endValue)
  if (!start) return ''
  if (!end) return `${dateFormat.format(start)} · ${timeFormat.format(start)}`
  if (start.toDateString() === end.toDateString()) {
    return `${dateFormat.format(start)} · ${timeFormat.formatRange(start, end)}`
  }
  return `${dateFormat.format(start)}, ${timeFormat.format(start)} – ${dateFormat.format(end)}, ${timeFormat.format(end)}`
}
